import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Config } from '../../app/config';

@Component({
	selector      : 'app-engage',
	templateUrl   : './engage.component.html',
	encapsulation : ViewEncapsulation.None
})

export class EngageComponent implements OnInit {
	@Input() engageWpData     : any;
	@Input() engageDotNetData : any;
	public loggedIn : boolean = false;
	public serverPath : any;

	constructor(
		private cfg : Config,
	) {		
		this.serverPath = this.cfg._apiSite || 'http://programmev2.worldwaterweek.org/';
		if ( 'userData' in window.localStorage )
            this.loggedIn = true;
	}

	ngOnInit() {}

	ngAfterViewInit() {
		document.querySelector( 'body' ).classList.add( 'body-engage-page' );
	}

	accordion( event : any, classname : string ) {
		const target   = event.target;
		const hasClass = target.parentElement.classList.contains( classname );
		if( hasClass )
			target.parentElement.classList.remove( classname );
		else {
			var elems = document.querySelectorAll( '.' + classname );
			[].forEach.call( elems, function( el ) {
				el.classList.remove( classname );
			});
			target.parentElement.classList.add( classname );
		}
		setTimeout( () => {
			const scrollElement = document.querySelector( '.' + classname );
			const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
			let yOffset;
			yOffset = -60;
			window.scrollTo({
				top: yCoordinate + yOffset,
				behavior: 'smooth'
			});
		}, 1 );
	}

	goToLoginPage( linkto ) {
		document.getElementById( 'pageaccountclick' ).click();
		window.localStorage.setItem( 'httpReferer', linkto );
	}
}